module.exports = __webpack_public_path__ + "static/img/function4.95ce0058.png";